import { BOOLEAN_OPTIONS } from "@/constant/GeneralOptions/boolean";

const getCountryInitialValues = (showData = null) => {
  const data = showData?.data;
  return {
    region: data?.region || "",
    country_id: data?.country?.id || "",
    customs_region: data?.customs_region || "",
    country_phone_code: data?.country?.phone_code || "",
    country_tld: data?.country?.tld || "",
    tld_owned: data?.tld_owned ?? BOOLEAN_OPTIONS.NO,
    country_code: data?.country?.code || "",
    country_code_alpha_3: data?.country?.code_alpha_3 || "",
    enable_professional_user: data?.enable_professional_user ?? BOOLEAN_OPTIONS.NO,
    enable_personal_user: data?.enable_personal_user ?? BOOLEAN_OPTIONS.NO,
    vat_merchandise: data?.vat_merchandise || 0,
    vat_e_service: data?.vat_e_service || 0,
    ship_to_location_code: data?.ship_to_location?.code || "",
    language_code: data?.language?.code || "",
    currency_code: data?.currency?.code || "",
    sport_id: data?.sport?.id || "",
  }
};

export default getCountryInitialValues;
